const STORAGE_PREFIX_NORMALIZED_LABELS = 'HAVE-LABELS-BEEN-NORMALIZED-';

class BrowserStorage {
    static getLabelsNormalizationStatus(extractionId: number) {
        return localStorage.getItem(`${STORAGE_PREFIX_NORMALIZED_LABELS}${extractionId}`) === 'true';
    }

    static setLabelsNormalizationStatus(extractionId: number, status: boolean) {
        localStorage.setItem(`${STORAGE_PREFIX_NORMALIZED_LABELS}${extractionId}`, String(status));
    }

    static deleteLabelsNormalizationStatus(extractionId: number) {
        localStorage.removeItem(`${STORAGE_PREFIX_NORMALIZED_LABELS}${extractionId}`);
    }
}

export default BrowserStorage;
